import React from 'react';
import ActivityConfigurationFlow from '../../../activity-creator/components/ActivityConfigurationFlow';
import { useActivityTemplates } from '../../../activity-creator/hooks/useActivityTemplates';

/**
 * WizardActivityConfigStep - Configure a single activity during wizard flow
 * Uses the shared ActivityConfigurationFlow component with wizard-mode customizations
 */
export const WizardActivityConfigStep = ({
  childId,
  childUsername,
  templateKey,
  currentIndex,
  totalCount,
  onComplete,
  onSkip,
  onBack
}) => {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  const isTestMode = true; // Always enable test mode for data-testid

  // Fetch templates to find the current one
  const { templates, isLoading: templatesLoading } = useActivityTemplates(childId, csrfToken);
  const template = templates?.find(t => t.key === templateKey);

  // Loading state while fetching template
  if (templatesLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 text-muted">Đang tải...</p>
      </div>
    );
  }

  // Template not found
  if (!template) {
    return (
      <div className="alert alert-danger">
        Không tìm thấy hoạt động: {templateKey}
      </div>
    );
  }

  return (
    <ActivityConfigurationFlow
      childId={childId}
      childUsername={childUsername}
      template={template}
      csrfToken={csrfToken}
      onComplete={onComplete}
      onBack={onBack}
      isWizardMode={true}
      isTestMode={isTestMode}
      onSkip={onSkip}
      currentIndex={currentIndex}
      totalCount={totalCount}
    />
  );
};
